import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { fetchOrder } from '../../api/orders/fetchOrder';

type UseOrderOptions = {
    readonly fetchFunc?: typeof fetchOrder;
};

export const useOrderQuery = (orderId, { fetchFunc = fetchOrder }: UseOrderOptions = {}) => {
    return useQuery(['order', orderId], () => fetchFunc(orderId), {
        ...GlobalReactQueryOptions,
        keepPreviousData: true
    });
};
